import React from 'react'

import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from '@mui/material/Paper';
import ComponentCard from "./Component";
import ComponentPreview from "./Preview";
import SubComponentCard from "./SubComponent";

export default function EMentor({ eMentor, tl, dir, componentCommentsCount }) {
  return (
    <ComponentCard title="e-Mentor Notes:" id="eMentor" commentsCount={componentCommentsCount("eMentor")}>
      {eMentor.map((data, index) => (
        <SubComponentCard key={data.id} title={"Note " + (index + 1)} id={data.id} commentsCount={componentCommentsCount(data.id)}>
          <Paper elevation={0} square className="p-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} font-bold m-0`}
                  dir={dir}
                >
                  {data.title}
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Content:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography 
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.content }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Source:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography className="text-14 m-0 break-all">
                      {data.source}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>
      ))}
    </ComponentCard>
  )
}
